export { a as consola, c as createConsola, a as default } from './shared/consola.36c0034f.mjs';
export { Consola, LogLevels, LogTypes } from './core.mjs';
import './shared/consola.06ad8a64.mjs';
import 'node:process';
import './utils.mjs';
import 'node:tty';
import 'node:util';
import 'node:path';
